export default __webpack_public_path__ + "static/media/Blade's Jerkin of Malice.05cd4227.jpg";